// src/auth/sessionAuth.js
const KEY = "panel_auth_v1";

export function getSessionUser() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setSessionUser(user) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(user));
  } catch {}
}

export function clearSessionUser() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {}
}

export function isAuthed() {
  return !!getSessionUser();
}
